import { useMemo } from "react";
import type { FieldUnion } from "./utils/field-type-guards";
import { WorkflowsTable, type TableColumn } from "../workflows-table/workflows-table";

export type FieldRow = {
  id: string;
  name: string;
  type: string;
  required: boolean;
  originalObj: FieldUnion;
  order: number;
};

type Props = {
  localFields: FieldUnion[];
  selectedIndex: number | null;
  onSelectRow: (index: number | null) => void;
  onAdd: () => void;
  onDelete: () => void;
  onReorder: (newItems: FieldRow[], oldIndex?: number, newIndex?: number) => void;
};

const TABLE_COLUMNS: TableColumn<FieldRow>[] = [
  { label: "Field Name", key: "name" },
  { label: "Field Type", key: "type" },
  {
    label: "Required",
    key: "required",
    render: (value) => (value ? "Yes" : "No"),
  },
];

export const MetadataFieldList = ({
  localFields,
  selectedIndex,
  onSelectRow,
  onAdd,
  onDelete,
  onReorder,
}: Props) => {
  const data = useMemo(() => {
    return localFields
      .map((field, index) => ({
        id: `${field.name}-${index}`,
        name: field.name,
        type: field.options && field.options.length > 0 ? "Choices" : field.type,
        required: field.required,
        originalObj: field,
        order: field.order || 0,
      }))
      .sort((a, b) => a.order - b.order);
  }, [localFields]);

  return (
    <WorkflowsTable
      className="h-80 max-h-80 w-full"
      isSortable
      columns={TABLE_COLUMNS}
      data={data}
      onReorder={onReorder}
      onClickAdd={onAdd}
      selectedIndex={selectedIndex}
      onSelectRow={onSelectRow}
      addButtonLabel="Create new field"
      dropdownMenuItems={[
        {
          id: "delete",
          label: "Delete field",
          onClick: onDelete,
        },
      ]}
    />
  );
};
